import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { filesListDummy } from './dummies';
import { MissingBlockDataError } from './InvalidBlockError';

@Component({
  selector: 'ca-media-table',
  imports: [CommonModule],
  template: `
  @if (data){
    <div id="media-table" class="mobilescroll">
      <table>
        <thead>
          <tr>
            <th>{{ columnNames.name }}</th>
            <th>{{ columnNames.extension }}</th>
            <th>{{ columnNames.actions }}</th>
          </tr>
        </thead>
        <tbody>
          @for (file of data.files; track file.id) {
            <tr>
              <td>{{ file.name }}</td>
              <td>{{ file.extension }}</td>
              <td>
                <button (click)="downloadFile(file)" aria-label="Download" class="material-symbols-outlined download"> download </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>}`,
})
export class MediaTableComponent {
  // @Input() data!: FilesTable;
  @Input() columnNames: { name: string; extension: string; actions: string } = {
    actions: 'Actions',
    extension: 'File type',
    name: 'Filename',
  };
  @Input() data?: MediaTableData;

  downloadFile(file: MediaTableData['files'][number]) {
    const link = document.createElement('a');
    link.href = file.downloadUrl;
    link.download = file.name;
    link.click();
  }
}

export interface MediaTableData {
  cssClass: null | string;
  files: {
    id: number | string;
    name: string;
    extension: string;
    downloadUrl: string;
    previewUrl?: string;
  }[];
}
